// Slovak

export default {

  component: {
    jobAdList: {
      title: 'Otvorené pracovné pozície',
      jobs: 'zamestnania',
      noJobAds: 'Momentálne nie sú otvorené žiadne pozície.',
    },

    jobAdCard: {
      openUntil: date => `Otvorené do ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Ďakujeme.',
      readyInfo: 'Vaša žiadosť bola prijatá a čoskoro vás bude kontaktovať náborár.',
      luck: 'Prajem vám veľa šťastia!',
    },

    jobAdSeeYou: {
      title: 'Ďakujeme.',
      description: 'Vaša žiadosť je uložená a odoslali sme odkaz umožňujúci pokračovať s ňou neskôr.',
    },


    unpublished: {
      title: 'Ponuka neuverejnená',
      info: 'Táto pracovná ponuka zatiaľ nebola uverejnená.',
    },
  },

  page: {},

}
